import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IHiddenElementAssignment } from '../../shared/service/role-based-element-hide.model';

export const componentPermissionActions = createActionGroup({
  events: {
    loadCurrentUserAssignments: emptyProps(),
    setCurrentUserAssignmentsToStore: props<{ assignments: IHiddenElementAssignment[] }>(),
  },
  source: 'component-permission',
});
